import { startEditingAction } from '../designerReducer';

import defaultBlogDesign from '@/configs/defaultBlogDesign';

export const startNewDesign = name => dispatch => {
  dispatch(startEditingAction({ ...defaultBlogDesign, name }));
};
